<template>
    <div :class="$style.wrapper">
        <h1>个人中心</h1>
        <div>
            <div style="flex: 0.2">
                <div :class="$style.avatar">
                    <img :src="`${'http://shop.gzestars.com/'+userInfo.avatar}`" alt="">
                    <div>
                        <h2>{{userInfo.user_name}}</h2>
                        <span v-if="userInfo.user_type==3">员工号：{{userInfo.staff_sn}}</span>
                    </div>
                </div>
                <ul :class="$style.menu">
                    <li @click="setUserInfoTab(1)" :class="{[$style.chosen]: userInfoTab === 1}">个人信息</li>
                    <li @click="setUserInfoTab(2)" :class="{[$style.chosen]: userInfoTab === 2}">头像修改</li>
                    <li @click="setUserInfoTab(3)" :class="{[$style.chosen]: userInfoTab === 3}">收货地址管理</li>
                </ul>
            </div>
            <div :class="$style.content">
                <UserInfo-User v-if="userInfoTab === 1"></UserInfo-User>
                <UserInfo-Avatar v-else-if="userInfoTab === 2"></UserInfo-Avatar>
                <UserInfo-Address v-else></UserInfo-Address>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapMutations, mapState } from 'vuex';
    import UserInfo from '../components/UserInfo';

    Vue.component('UserInfo-Address', UserInfo.Address);
    Vue.component('UserInfo-User', UserInfo.User);
    Vue.component('UserInfo-Avatar', UserInfo.Avatar);
    export default {
        data () {
            return {};
        },
        methods: {
            ...mapMutations(['setUserInfoTab']),
        },
        computed: {
            ...mapState(['userInfoTab']),    //个人中心里的tab，1个人信息，2头像修改，3收货地址管理
            ...mapState(['userInfo'])
        },
    };
</script>

<style lang="less" module>
    .wrapper {
        & > h1 {
            margin-top: 0;
            margin-bottom: 25px;
            font-size: 24px;
        }
        & > div {
            background: #ffffff;
            box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
            width: 1525px;
            height: 740Px;
            display: flex;

            .content {
                flex: 0.8;
                border-left: 1px solid #D1D1D1;
                padding: 0 40px;
            }
            .avatar {
                padding: 20px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #D1D1D1;
                & > img {
                    width: 64px;
                    height: 64px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                h2 {
                    margin-top: 0;
                    margin-bottom: 8px;
                    font-size: 20px;
                }
                span {
                    font-size: 14px;
                    color: #9ca2ad;
                }
            }
            .menu {
                list-style-type: none;
                margin: 0;
                padding: 0;
                & > li {
                    height: 64px;
                    line-height: 64px;
                    text-align: center;
                    font-size: 20px;
                    color: #1f2329;
                    border-bottom: 1px solid #D1D1D1;
                    cursor: pointer;
                    &:hover {
                        .chosen;
                    }
                }
                .chosen {
                    background: #e6e8eb;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/router/UserInfo.vue